import {AdUnitActionBar} from '@/pages/ad-unit/AdUnitActionBar.tsx'
import AdUnitCode from '@/pages/ad-unit/AdUnitCode'
import {Modal, Switch} from 'antd'
import {AdUnitBean, ListResponseAdUnitBean} from 'common/api/api'
import {adUnitApi} from 'common/api/entitiesApi.tsx'
import {ActiveStatusSelector} from 'common/components/dictionary/ActiveStatusSelector.tsx'
import {ListCard} from 'common/components/ListCard.tsx'
import {PublisherSelector} from 'common/components/reloadable/PublisherSelector.tsx'
import {SiteSelector} from 'common/components/reloadable/SiteSelector.tsx'
import {SearchInput} from 'common/components/SearchInput.tsx'
import {ListFilters, useAppContext} from 'common/context/AppContext.tsx'
import {CommonRoutes} from 'common/context/commonRoutes'
import {useUserContext} from "common/context/UserContext.tsx"
import {COLUMN_ID_WIDTH, COLUMN_NAME_WIDTH} from 'common/util/constants.ts'
import {initListFilters, useListFilters} from 'common/util/useListFilters.ts'
import {apiCall} from 'common/util/Util.tsx'
import dayjs from 'dayjs'
import * as React from 'react'
import {useState} from 'react'
import {Link, useParams} from 'react-router-dom'

const AdUnitList: React.FC = () => {
//    const [isBulk, setIsBulk] = useState(false)
//    const [isBulkUpdate, setIsBulkUpdate] = useState(false)

    const { user } = useUserContext();
    const [listData, setListData] = useState<ListResponseAdUnitBean>()
    const appContext = useAppContext()
    const [loading, setLoading] = useState<boolean>(false)
    const {commonId} = useParams<{commonId?: string}>()
    const publisherId = commonId && !Number.isNaN(Number(commonId)) ? Number(commonId) : undefined

    const [filters, setFilters] = useState<ListFilters>(initListFilters({publisherId}))
    const {setFilter} = useListFilters(setFilters)

    const [showCodeModal, setShowCodeModal] = useState(false)
    const [selectedAdUnit, setSelectedAdUnit] = useState<AdUnitBean | null>(null)

    const generateHtmlTag = (adUnit: AdUnitBean) => {
        setSelectedAdUnit(adUnit)
        setShowCodeModal(true)
    }

//    const toggleBulk = () => setIsBulk(!isBulk)
//    const toggleBulkUpdate = () => setIsBulkUpdate(!isBulkUpdate)

//    const handleCsv = () => {
//        adUnitApi.getAdUnitCsv('ZoneList.csv').catch(onError)
//    }

    const loadData = () => {
        apiCall(setLoading, appContext,
            () => adUnitApi.adUnitPage(
                filters.sort?.name,
                filters.sort?.direction,
                filters.name,
                filters.active,
                filters.siteId,
                filters.publisherId,
                {query: {page: filters.page, size: filters.pageSize}}
            ),
            (bean: ListResponseAdUnitBean) => setListData(bean))
    }

    const toggleActive = (id: number | undefined, record: AdUnitBean, checked: boolean) => {
        if (id === undefined) return
        apiCall(setLoading, appContext,
            () => adUnitApi.setAdUnitActive(id, checked),
            () => {
                record.active = checked
                setListData(listData)
            })
    }

    return (
        <div>
            <ListCard
                loading={loading}
                title="Ad Units"
                listRouteKey={CommonRoutes.AD_UNIT}
                filters={filters}
                setFilters={setFilters}
                loadData={loadData}
                listData={listData}
                createName="Ad Unit"
                createRoute={CommonRoutes.AD_UNIT_CREATE}
                columns={[
                    {
                        title: 'ID',
                        dataIndex: 'id',
                        width: COLUMN_ID_WIDTH,
                        fixed: 'left'
                    },
                    {
                        title: 'Name',
                        dataIndex: 'name',
                        sorter: true,
                        render: (text, record: AdUnitBean) => (
                            <Link
                                style={{color: '#5888CF'}}
                                to={`${CommonRoutes.AD_UNIT}/${record.id}/edit`}>
                                {text}
                            </Link>),
                        className: 'list-table-name',
                        ellipsis: true,
                        width: COLUMN_NAME_WIDTH,
                        fixed: 'left'
                    },
                    {
                        title: 'Token',
                        dataIndex: 'token',
                        width: COLUMN_ID_WIDTH,
                        fixed: 'left'
                    },
                    {
                        title: 'Publisher',
                        dataIndex: 'publisherName',
                        width: 120
                    },
                    {
                        title: 'Site',
                        dataIndex: 'siteName',
                        width: 120
                    },
                    {
                        title: 'Size',
                        dataIndex: 'size',
                        width: 120,
                        render: (_, record) => record.width + "x" + record.height
                    },
                    {
                        title: 'Revenue Type',
                        dataIndex: 'revenueType',
                        width: 60
                    },
                    {
                        title: "Last Modified",
                        dataIndex: "modified",
                        sorter: true,
                        width: 100,
                        render: (date) => date && dayjs(date).format('DD MMM YYYY')
                    },
                    {
                        title: 'Active',
                        dataIndex: 'active',
                        sorter: true,
                        render: (val, record) => (
                            <Switch
                                size="small"
                                checked={record.active}
                                onChange={(checked, _event) => toggleActive(record.id, record, checked)}
                            />
                        ),
                        width: 60
                    },
                    {
                        key: 'action',
                        title: 'Actions',
                        render: (_text: string, record: AdUnitBean) => (
                            <AdUnitActionBar
                                record={record}
                                generateCode={() => generateHtmlTag(record)}
                            />
                        ),
                        width: 240
                    }
                ]}>
                <SearchInput placeholder="Search by ID, Name, Token" width="250px" value={filters.name} onChange={(value) => setFilter('name', value)} />
                <ActiveStatusSelector
                  placeholder="Filter by Active"
                  style={{ minWidth: '100px' }}
                  value={filters.active}
                  onChange={(value) => setFilter('active', value)}
                />
                <PublisherSelector
                    placeholder="Filter by Publisher"
                    style={{minWidth: '200px'}}
                    value={filters.publisherId}
                    onChange={(value) => setFilter('publisherId', value)}
                />
                <SiteSelector
                    placeholder="Filter by Site"
                    style={{minWidth: '200px'}}
                    value={filters.siteId}
                    publisherId={filters.publisherId}
                    onChange={(value: number) => setFilter('siteId', value)}
                />
            </ListCard>
            <Modal
                open={showCodeModal}
                title={`${selectedAdUnit?.name || ''}`}
                cancelText="Close"
                onCancel={() => {
                    setShowCodeModal(false)
                    setSelectedAdUnit(null)
                }}
                okButtonProps={{style: {display: 'none'}}}
                width={'50%'}
            >
                {selectedAdUnit && <AdUnitCode agencyId={user?.agencyPublicId || 'UNKNOWN'} adUnit={selectedAdUnit}/>}
            </Modal>
        </div>
    )
}

export default AdUnitList
